module.exports = __webpack_public_path__ + "img/cloud.0c930fcf.png";